<!-- 配额酒制票通知单-->
<template>
  <div v-loading="loading" class="page-form page-base">
    <h3 class="title">{{ title }}</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button name="返回" @click="back" />
        <form-button v-if="edit && !isNew" name="显示" @click="edit = !edit" />
        <template v-if="conditions.inf_type !== 'ZB04'">
          <form-button
            v-if="!edit && $_has(['WLYALL', 'WLY002']) && conditions.inv_status !== 'E003'"
            name="修改"
            @click="edit = !edit"
          />
          <!--提交、取消、保存 role：WLY002、WLY004 -->
          <template v-if="edit">
            <form-button
              v-if="['E001'].includes(conditions.inv_status)"
              name="提交"
              type="primary"
              :loading="loading"
              @click="changeStatus('SUBMIT')"
            />
            <form-button
              v-if="conditions.inv_status === 'E003'"
              name="保存"
              type="primary"
              :loading="loading"
              @click="changeStatus('SAVE')"
            />
            <form-button
              v-if="['E002', 'E003'].includes(conditions.inv_status)"
              name="取消"
              :loading="loading"
              icon="form-advance"
              @click="changeStatus('CANCEL')"
            />
            <form-button
              v-if="conditions.inv_status === 'E004'"
              name="审核通过"
              :loading="loading"
              @click="changeStatus('APPROVE')"
            />
            <form-button
              v-if="($_has('WLY004') || $_has('WLYALL')) && conditions.inv_status === 'E005'"
              name="生成对冲制票单"
              :loading="loading"
              @click="hedge"
            />
          </template>
          <!--
          重传中转仓系统 role: WLYALL、WLY002
          重传开票系统 role: WLYALL、WLY002、WLY004
          生产对冲制票单：role：WLY004
          重传中转仓系统、重传开票系统：需要请求接口
          打印： role：WLYALL、WLY002
        -->
          <template v-else>
            <template v-if="conditions.inv_status === 'E005'">
              <form-button
                v-if="$_has(['WLYALL', 'WLY002']) && mesid_zzc"
                name="重传中转仓系统"
                @click="reSend('TOZZC')"
              />
            </template>
            <template
              v-if="conditions.inv_status === 'E003' && $_has(['WLY002', 'WLYALL', 'WLY004'])"
            >
              <form-button
                v-if="['ZB01', 'ZB02'].includes(conditions.inf_type)"
                name="创建后续"
                @click="createNext"
              />
              <form-button v-if="mesid_kp" name="重传开票系统" @click="reSend('TOKP')" />
            </template>
          </template>
          <form-button v-if="!edit && conditions.inv_status !== 'E001'" name="打印" @click="printDialog" />
        </template>
        <!-- 批条酒类型按钮 -->
        <template v-else>
          <form-button
            v-if="!conditions.invo_infoid && $_has(['WLY004', 'WLY006', 'WLYALL'])"
            name="提交"
            type="primary"
            :loading="loading"
            @click="changeStatus('SUBMIT')"
          />

          <template v-if="conditions.invo_infoid && !edit">
            <template v-if="conditions.inv_status === 'E003'">
              <form-button
                v-if="!edit && $_has(['WLYALL', 'WLY004', 'WLY006'])"
                name="修改"
                @click="edit = !edit"
              />
              <form-button v-if="mesid_kp" name="重传开票系统" @click="reSend('TOKP')" />
            </template>
            <template v-else-if="conditions.inv_status === 'E005'">
              <form-button
                v-if="$_has(['WLY006', 'WLYALL'])"
                name="重传中转仓系统"
                @click="reSend('TOZZC')"
              />
            </template>
            <template v-else-if="conditions.inv_status !== 'E006'">
              <form-button
                v-if="!edit && $_has(['WLYALL', 'WLY006'])"
                name="修改"
                @click="edit = !edit"
              />
            </template>

            <form-button v-if="$_has(['WLYALL', 'WLY002'])" name="打印" @click="printDialog" />
          </template>

          <template v-if="edit && conditions.invo_infoid && $_has(['WLYALL', 'WLY004', 'WLY006'])">
            <template v-if="conditions.inv_status === 'E002'">
              <form-button
                name="提交"
                :loading="loading"
                @click="changeStatus('SUBMIT')"
              />
              <form-button
                name="取消"
                :loading="loading"
                icon="form-advance"
                @click="changeStatus('CANCEL')"
              />
            </template>
            <template v-if="conditions.inv_status === 'E003'">
              <form-button
                name="保存"
                :loading="loading"
                @click="changeStatus('SAVE')"
              />
              <form-button
                name="取消"
                :loading="loading"
                icon="form-advance"
                @click="changeStatus('CANCEL')"
              />
            </template>
            <template v-if="conditions.inv_status === 'E004'">
              <form-button
                name="审核通过"
                :loading="loading"
                @click="changeStatus('APPROVE')"
              />
            </template>
          </template>
        </template>
      </div>
      <el-form
        ref="form"
        inline
        :show-message="false"
        size="mini"
        label-width="120px"
        :model="conditions"
        :rules="rules"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="制票通知单号">
              <el-input v-model="conditions.invo_infoid" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="外部制票通知单号" class="line-16">
              <el-input v-model="conditions.w_invo_infoid" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="制票通知单类型" class="line-16">
              <el-select v-model="conditions.inf_type" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0022']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户编码">
              <el-input v-model="conditions.customer" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户名称">
              <el-input v-model="conditions.cust_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收票联系人">
              <el-input v-model="conditions.recinv_pers" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收票联系人电话" class="line-16">
              <el-input v-model="conditions.recinv_tel" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否已打印">
              <el-checkbox
                v-model="conditions.mark_print_dscr"
                disabled
                true-label="X"
                false-label=""
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票类型" prop="inv_type">
              <el-select v-model="conditions.inv_type" :disabled="isEdit" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0032']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="换票日期">
              <el-date-picker
                v-model="conditions.chan_date"
                disabled
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票日期">
              <el-date-picker
                v-model="conditions.mak_date"
                disabled
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票金额">
              <el-input v-model="conditions.inv_amount" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="定制名称">
              <el-input v-model="conditions.zcustom_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收票地址">
              <el-input v-model="conditions.zzfld00002n" type="textarea" rows="2" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input v-model="conditions.remark" :disabled="isEdit" type="textarea" rows="2" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.audit_comment"
                :disabled="isEdit"
                type="textarea"
                rows="2"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注2">
              <el-input v-model="conditions.remark2" :disabled="isEdit" type="textarea" rows="2" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发运备注">
              <el-input v-model="conditions.shipment_remark" :disabled="isEdit" type="textarea" rows="2" />
            </el-form-item>
          </el-col>
        </el-row>

        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input v-model="conditions.zzfld00002d_dscr" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                disabled
                type="date"
                value-format="yyyyMMdd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select v-model="conditions.inv_status" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0033']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-input v-model="conditions.zzfld000001_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input v-model="conditions.additional" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省区">
              <el-input v-model="conditions.zzfld000002_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input v-model="conditions.zzfld000003_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input v-model="conditions.zzfld000004_dscr" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 配额不显示收货地址信息 -->

        <template v-if="conditions.inf_type !== 'ZS01'">
          <common-title title="运达方" />
          <el-col :lg="8" :md="12">
            <el-form-item label="客户性质" class="line-16">
              <el-input v-model="conditions.zzfld00002j_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发货类型" class="line-16">
              <el-input v-model="conditions.zzfld00002k_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货联系人" class="line-16">
              <el-input v-model="conditions.zzfld00002l" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货联系电话" class="line-16">
              <el-input v-model="conditions.zzfld00002m" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货地址" class="line-16">
              <el-input v-model="conditions.zzfld00002n" disabled />
            </el-form-item>
          </el-col>
        </template>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="行项目" :custome-config="() => vxeShowCustom('gridOptions')">
        <!-- <template v-if="isEditPC" #button>
          <table-button tip="新增" name="add" @click="addRow" />
          <table-button tip="删除" name="delete" @click="removeRow" />
        </template> -->
        <vxe-grid
          ref="gridOptions"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #net_value="{row, $rowIndex }">
            <el-input v-if="isEditPC && $rowIndex" v-model="row.net_value" :disabled="!$rowIndex" type="number" size="mini" @keydown.enter.native="confirmNetValue($event, row)" />
            <span v-else>{{ row.net_value }}</span>
          </template>
          <template #warehouse="{ row, $rowIndex }">
            <el-select v-if="!$rowIndex" v-model="row.warehouse" size="mini" :disabled="isEdit">
              <el-option
                v-for="item in selectDataOptions['A0039']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
            <span v-else>{{ row.warehouse }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="剩余现金奖励" :custome-config="() => vxeShowCustom('fileTable')" v-if="role.ROLE == 'WLY002' || role.ROLE == 'WLYALL'">
        <template #button>
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsCash.columns"
          :data="gridOptionsCash.data"
        >
          <!-- <template #toolbar /> -->
          <!-- <template #FILENAME="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template> -->
        </vxe-grid>
      </TableCommon>
      <TableCommon
        v-if="conditions.inf_type === 'ZB01' || conditions.inf_type === 'ZB02'"
        title="占用销售计划明细"
        :custome-config="() => vxeShowCustom('gridOptionsDetail')"
      >
        <vxe-grid
          ref="gridOptionsDetail"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsDetail.columns"
          :data="gridOptionsDetail.data"
        />
      </TableCommon>

      <TableCommon
        v-if="conditions.inf_type === 'ZB01' || conditions.inf_type === 'ZB02'"
        title="关联制票通知单"
        :custome-config="() => vxeShowCustom('gridOptionsAssociated')"
      >
        <vxe-grid
          ref="gridOptionsAssociated"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsAssociated.columns"
          :data="gridOptionsAssociated.data"
        />
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('gridOptionsHistory')">
        <vxe-grid
          ref="gridOptionsHistory"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="浏览制票通知单"
      width="70%"
      top="5vh"
    >
      <iframe :src="url" frameborder="0" style="width: 100%;height: 600px" />

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmPrint"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiSubmit,
  apiMakeInvoiceDetail,
  apiReSend,
  apiCreateNext,
  apiGetDetailById,
  printInvoice
} from '@/api/sap/make-invoice-sap'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import { hexToBytes } from '@/utils/frontExport'

let invo_infoid = ''
export default {
  props: {
    selectData: {
      type: Object,
      default: () => null
    },
    fromPage: {
      type: String,
      default: ''
    }
  },
  data() {
    const rules = {
      inv_type: [{ required: true, message: '请选择发票类型', trigger: 'blur' }]
    }
    return {
      rules,
      showDialog: false,
      url: '',
      mesid_zzc: '',
      mesid_kp: '',
      isNew: true,
      edit: true,
      loading: false,
      errorList: [],
      conditions: {},
      info: {},
      selectDataOptions: {},
      gridOptions: {
        columns: [
          // { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'ordered_prod', title: '产品编号', width: 120 },
          { field: 'description', title: '产品描述', width: 120 },
          { field: 'zzfld00002s', title: '规格型号', width: 120 },
          { field: 'use_quantity', title: '开票数量', width: 120 },
          { field: 'use_zzfld9', title: '开票件数', width: 120 },
          { field: 'use_bot', title: '开票瓶数', width: 120 },
          { field: 'zzfld00002t', title: '单位', width: 120 },
          { field: 'zzfld00002e', title: '税率', width: 120 },
          { field: 'net_price', title: '含税单价', width: 120 },
          { field: 'net_value', title: '价税合计', width: 120, slots: { default: 'net_value' }, params: { bgEdit: true }},
          { field: 'zzfld00002a_text', title: '折扣类型', width: 120 },
          { field: 'zzfld00002f', title: '单品折扣', width: 120 },
          { field: 'zzfld00002g', title: '折后含税单价', width: 120 },
          { field: 'zzfld00002i', title: '折扣额', width: 120 },
          { field: 'object_id', title: '销售订单号', width: 120 },
          { field: 'number_int', title: '销售订单号行项目', width: 150 },
          { field: 'cust_name', title: '订单客户', width: 120 },
          { field: 'reward_type_text', title: '奖励类型', width: 120 },
          { field: 'reward_number', title: '奖励编号', width: 120 },
          { field: 'reward_name', title: '项目/计划编号', width: 120 },
          { field: 'send_qty', title: '已发运件数', width: 120 },
          { field: 'guaranty', title: '随货保证金', width: 120 },
          { field: 'invo_id', title: '发票号', width: 120 },
          { field: 'manual_invo', title: '提货票', width: 120 },
          { field: 'warehouse', title: '仓库', width: 120, slots: { default: 'warehouse' }, params: { bgEdit: true }},
          { field: 'remark', title: '备注', width: 120 }
        ],
        data: []
      },
      gridOptionsCash: {
        columns: [
          {
            field: 'reward_number',
            title: '项目奖励编码',
            width: 120
          },
          {
            field: 'reward_id',
            title: '项目类型编码',
            width: 120
          },
          {
            field: 'reward_name',
            title: '项目类型描述',
            width: 180
          },
          {
            field: 'customer',
            title: '项目客户编码',
            width: 120
          },
          {
            field: 'customer_name',
            title: '项目客户名称',
            width: 180
          },
          {
            field: 'start_date',
            title: '有效期起',
          },
          {
            field: 'end_date',
            title: '有效期止',
          },
          {
            field: 'quota_ratio',
            title: '额度比例(%)',
          },
          {
            field: 'amount',
            title: '项目金额（元）',
          },
          {
            field: 'remain_amount',
            title: '剩余金额（元）',
          },
        ],
        data: [],
        delData: []
      },
      gridOptionsDetail: {
        columns: [
          { field: 'zzfld00000c', title: '销售计划编号', width: 120 },
          { field: 'zzfld00000d_text', title: '计划类型', width: 120 },
          { field: 'zzfld00000e_text', title: '存货分类', width: 120 },
          { field: 'zzfld00000f', title: '年度', width: 60 },
          { field: 'zzfld00000g', title: '月份', width: 60 },
          { field: 'order_zzfldr', title: '订单占用计划量(件)' },
          { field: 'order_remain', title: '订单可开票量(件)' },
          { field: 'zzfld00000r', title: '本次开票占用量(件)' },
          { field: 'order_zzfldr_bot', title: '订单占用计划量(瓶)' },
          { field: 'order_remain_bot', title: '订单可开票量(瓶)' },
          { field: 'curnt_atpbot', title: '本次开票占用量(瓶)' }
        ],
        data: []
      },
      gridOptionsAssociated: {
        columns: [
          { field: 'invo_infoid2', title: '关联制票通知单号' },
          { field: 'inf_type2_text', title: '制票通知单类型' },
          { field: 'inv_status2_text', title: '制票通知单状态' },
          { field: 'datum', title: '创建日期' }
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'role']),
    isEdit() {
      return !this.edit
    },
    // 是否能编辑瓶储
    isEditPC() {
      return !this.conditions.invo_infoid && this.conditions.zzfld000001_text === '瓶储'
    },
    title() {
      if (this.selectDataOptions?.A0022 && this.conditions?.inf_type) {
        return this.selectDataOptions['A0022'].find(v => v.value === this.conditions.inf_type).name
      } else {
        return '制票通知单'
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0022')
    this.getSelectDictDataOrigin('A0032')
    this.getSelectDictDataOrigin('A0033')
    this.getSelectDictDataOrigin('A0039')
    if (this.selectData.invo_infoid) {
      this.getInvoiceDetail(this.selectData.invo_infoid)
      this.edit = false
      this.isNew = false
    } else {
      this.getDetail('init')
    }
  },
  methods: {
    cellClassName({ column }) {
      if (column.params?.bgEdit) {
        return 'cell--bg--edit'
      } else {
        return 'cell--bg--default'
      }
    },
    printDialog() {
      printInvoice({
        user_bp: this.$store.getters.role.USER_BP,
        invo_infoid: [this.conditions.invo_infoid]
      }).then(res => {
        this.showDialog = true
        var uint8Array = new Uint8Array(hexToBytes(res.data))
        var blob = new Blob([uint8Array], { type: 'application/pdf' })
        this.url = URL.createObjectURL(blob)
      })
    },
    async confirmMode(type) {
      const types = {
        SUBMIT: '提交',
        CANCEL: '取消',
        REJECT: '审核拒绝',
        APPROVE: '审核通过'
      }
      if (!types[type]) {
        return Promise.resolve()
      }
      await this.$confirm(`是否确认${types[type]}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    async changeStatus(mode) {
      // await this.confirmMode(mode)
      const params = {
        mode,
        user_bp: this.role.USER_BP,
        info: this.info,
        head: { ...this.conditions },
        item: [...JSON.parse(JSON.stringify(this.gridOptions.data))],
        use: [...JSON.parse(JSON.stringify(this.gridOptionsDetail.data))],
        connect: [...JSON.parse(JSON.stringify(this.gridOptionsAssociated.data))],
        cash: [...JSON.parse(JSON.stringify(this.gridOptionsCash.data))]
      }
      params.item.length && params.item.forEach(v => delete v._X_ID)
      params.use.length && params.use.forEach(v => delete v._X_ID)
      params.connect.length && params.connect.forEach(v => delete v._X_ID)
      delete params.head.mark_print_dscr
      this.errorList = []
      try {
        this.$refs.form.validate(async(valid, err) => {
          if (valid) {
            // 验证瓶储，是否添加了行项目，且都有值。。。
            if (mode === 'SUBMIT' && this.isEditPC && params.item[0].net_value < Math.abs(params.item[1].net_value)) {
              await this.$confirm('折扣价格超过价税合计，是否继续提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
            }
            this.loading = true

            const result = await apiSubmit(params)
            if (result.msgtype === 'S') {
              if (result?.head) {
                await this.getInvoiceDetail(result.info.invo_infoid)
                this.edit = false
                this.isNew = false
              }
              if (this.fromPage === 'create') {
                // 如果是工作台进入的，成功之后删除工作台这条数据
                this.$emit('edit-workbench', result.info.invo_infoid)
              }
              this.$message.success(result.message)
            } else {
              this.loading = false
              this.errorList.push(result.message)
            }
          } else {
            this.errorList = this.$utilsCommon.filterErrorMsg(err)
          }
        })
      } catch (e) {
        //
        this.loading = false
      }
    },
    // 瓶储 营销单元，行项目回车事件
    confirmNetValue(e, row) {
      const nRows = this.gridOptions.data.filter((v, i) => i)
      nRows.forEach(v => {
        if (row._X_ID !== v._X_ID) {
          v.net_value = row.net_value * -1
        }
        if (v.net_value < 0) {
          v.zzfld00002a = 'V006'
          v.zzfld00002a_text = '销额扣减'
        } else {
          v.zzfld00002a = 'V007'
          v.zzfld00002a_text = '销售返利'
        }
      })
    },
    confirmPrint() {
      this.$confirm('确认已经打印此制票通知单！', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(res => {
        printInvoice({
          user_bp: this.$store.getters.role.USER_BP,
          invo_infoid: [this.conditions.invo_infoid],
          mode: 'X'
        }).then(res => {
          this.showDialog = false
          this.conditions.mark_print = 'X'
        })
      })
    },
    back() {
      if (this.isNew && invo_infoid) {
        this.getDetail()
        this.isNew = false
        this.edit = false
      } else {
        this.$emit('changeActive', this.fromPage)
      }
    },
    // 对冲
    hedge() {
      this.conditions.inv_amount = 0 - this.conditions.inv_amount
      for (const key in this.conditions) {
        if (
          [
            'audit_comment',
            'zzfld00002d_dscr',
            'zzfld00002d',
            'remark',
            'mak_date',
            'chan_date',
            'mark_print',
            'inv_guid',
            'w_invo_infoid',
            'zzfld00002d_dscr',
            'invo_infoid',
            'w_invo_infoid'
          ].includes(key)
        ) {
          this.conditions[key] = ''
        }
      }
      this.gridOptions.data.map(v => {
        v.guid = ''
        v.inv_guid = ''
        v.nvo_id = ''
        v.use_quantity = 0 - v.use_quantity
        v.use_zzfld9 = 0 - v.use_zzfld9
        v.net_value = 0 - v.net_value
        v.zzfld00002i = 0 - v.zzfld00002i
      })
      this.gridOptionsDetail.data.map(v => {
        v.parent_id = ''
        v.object_id = ''
        v.zzfld00000r = 0 - v.zzfld00000r
      })
      this.conditions.inv_status = 'E001'
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
      this.conditions.zzfld00002d = this.$store.getters.role.USER_BP
      this.conditions.zzfld00002d_dscr = this.$store.getters.role.login_user
      this.edit = true
    },
    // 重传
    async reSend(mode) {
      const params = {
        mode,
        head: this.conditions
      }
      this.errorList = []
      const res = await apiReSend(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        this.getInvoiceDetail(this.conditions.invo_infoid)
      } else {
        this.errorList.push(res.message)
      }
    },
    async getInvoiceDetail(id) {
      this.loading = true
      const { data, additional } = await apiGetDetailById({ INVO_INFOID: id })
      this.mesid_zzc = data.mesid_zzc
      this.mesid_kp = data.mesid_kp
      Object.assign(this.conditions, data.head)
      // this.conditions = data.head
      this.conditions.additional = additional
      this.gridOptionsHistory.data = data.history
      this.gridOptions.data = data.item
      this.gridOptionsAssociated.data = data.connect || []
      this.gridOptionsDetail.data = data.use || []
      this.gridOptionsCash.data = data.cash || []
      this.loading = false
    },
    // 创建后续 （线上该功能没有用过，需要用到可以解开代码）
    async createNext() {
      const item = JSON.parse(JSON.stringify(this.gridOptions.data))
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        head: this.conditions,
        item: item.map(v => {
          delete v._X_ID
          return v
        })
      }
      this.errorList = []
      const res = await apiCreateNext(params)
      if (res.msgtype === 'S') {
        invo_infoid = this.conditions.invo_infoid
        this.isNew = true
        this.edit = true
        this.conditions = res.data.head
        this.gridOptionsHistory.data = res.data.history
        this.gridOptions.data = res.data.item
        this.gridOptionsAssociated.data = res.data.connect || []
        this.gridOptionsDetail.data = res.data.use || []
      this.gridOptionsCash.data = data.cash || []
    } else {
        this.errorList.push(res.message)
      }
    },
    // // 如果是瓶储营销单元，那就可以添加行项目, 且最多添加两行
    // addRow() {
    //   // 获取已经添加了多少行
    //   const len = this.gridOptions.data.filter(v => !v.ordered_prod).length
    //   if (len >= 2) {
    //     this.errorList = ['最多添加两行！']
    //     return
    //   }
    //   const row = { net_value: '' }
    //   this.gridOptions.data.push(row)
    // },
    async getDetail(mode) {
      this.loading = true
      const info = JSON.parse(JSON.stringify(this.selectData))
      delete info._X_ID
      delete info._index
      const params = {
        inf_type: this.selectData.inf_type,
        info
      }
      params.partner = this.$store.getters.role.USER_BP
      const { data } = await apiMakeInvoiceDetail(params)
      this.loading = false
      this.edit = true
      this.info = data.info
      this.conditions = data.head
      this.conditions.additional = data.additional
      this.gridOptionsHistory.data = data.history
      this.gridOptions.data = data.item
      this.gridOptionsAssociated.data = data.connect || []
      this.gridOptionsDetail.data = data.use || []
      this.gridOptionsCash.data = data.cash || []
      // 如果是瓶储 直接初始化两行
      if (mode === 'init' && data.head.zzfld000001_text === '瓶储') {
        this.initPc()
      }
    },
    initPc() {
      const item = this.gridOptions.data[0]
      /**
       * 默认参数：
       * net_value: 1569780 || -1569780,
       * zzfld00002a: 'V007' || 'V006'
       */
      const rows = [
        {
          ordered_prod: item.ordered_prod,
          description: item.description,
          net_value: -1569780,
          zzfld00002a: 'V006',
          zzfld00002a_text: '销额扣减'
        },
        {
          ordered_prod: item.ordered_prod,
          description: item.description,
          net_value: 1569780,
          zzfld00002a: 'V007',
          zzfld00002a_text: '销售返利'
        }
      ]
      this.gridOptions.data.push(...rows)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/EntryInvoice.vue